<template>
	<div class="achievement">
		<div class="usercontexttop">
			<div>我的考试成绩</div>
			<div class="btnpage" v-if="pages>1">
				<a href="javascript:void(0);" class="pagebtn1 mr" @click="sy">首页</a>
				<a href="javascript:void(0);" class="pagebtn1 mr" @click="syy">上一页</a>
				<a href="javascript:void(0);" class="pagebtn2" v-if="pageslist!=null" v-for="index in pageslist" @click="clickpagenum(index)">{{index}}</a>
				<a href="javascript:void(0);" class="pagebtn1 ml" @click="xyy">下一页</a>
				<a href="javascript:void(0);" class="pagebtn1 ml" @click="wy">尾页</a>
			</div>
		</div>
		<div class="userborder">
			<div class="itemall" v-if="scoresList.length===0">
				<div class="ttttttt">当前没有考试记录哦,快去考试吧~~</div>
			</div>
			<div class="achievementitem" v-if="scoresList!=null" v-for="(item,index) in scoresList">
				<div class="flex1 flex_1">
					<img src="../../assets/images/usersj.png" />
					<p>{{setData(item.created_at)}}</p>
				</div>
				<div class="flex1 flex_2">
					<img src="../../assets/images/userscor.png" />
					<p><span>{{item.score}}分</span></p>
				</div>
				<div class="flex1 flex_3">
					<img src="../../assets/images/usersss.png" />
					<p>{{item.paperName}}</p>
				</div>
			</div>
		</div>
		<div class="btnpage2"  v-if="pages>1">
			<a href="javascript:void(0);" class="pagebtn11" @click="sy"><span>首页</span></a>
			<a href="javascript:void(0);" class="pagebtn11" @click="syy"><span>上一页</span></a>
			<a href="javascript:void(0);" class="pagebtn22" v-if="pageslist!=null" v-for="index in pageslist" @click="clickpagenum(index)"><span>{{index}}</span></a>
			<a href="javascript:void(0);" class="pagebtn11" @click="xyy"><span>下一页</span></a>
			<a href="javascript:void(0);" class="pagebtn11" @click="wy"><span>尾页</span></a>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'achievement',
		data(){
			return{
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				pageNum: 1,
				pageSize: 20,
				pages: 1,//总页数
				scoresList: [],//成绩列表
				pageslist: null,//只显示五页
			}
		},
		created(){
			this.getscoresList()
		},
		methods:{
			getscoresList(){
				new Promise((resolve, reject)=>{
					axios({
						url: this.$api.commonUrl + 'paper/scores',
						type: 'GET',
						params: {
							"userId": this.userid,
							"pageNum": this.pageNum,
							"pageSize": this.pageSize
						},
						headers: {
							"Authorization": "Bearer " + this.token
						}
					}).then(res => {
						if(res.data.code=='200'){
							this.scoresList = res.data.data.list
							this.pages = res.data.data.pages
							if(parseInt(res.data.data.pages)>=5){
								for(let i = 1;i<=5;i++){
									if(this.pageNum>2){
										this.pageslist = [this.pageNum-2,this.pageNum-1,this.pageNum,this.pageNum+1,this.pageNum+2]
									}
									if(this.pageNum<=2){
										this.pageslist = [1,2,3,4,5]
									}
									if(this.pageNum>=this.pages-2){
										this.pageslist = [this.pages-4,this.pages-3,this.pages-2,this.pages-1,this.pages]
									}
								}
							}else if(parseInt(res.data.data.pages)<5){
								let newlist = []
								for(let i = 1;i<=parseInt(res.data.data.pages);i++){
									newlist.push(i)
								}
								this.pageslist = newlist
							}
							resolve()
						}else{
							console.log(re.data.message)
						}
					}).catch(err => {
						console.log("learningrecords", err)
					})
				}).then(()=>{
					this.pushclass()
				})
			},
			clickpagenum(index){
				if(index!=this.pageNum){
					this.pageNum = index
					this.getscoresList()
				}
			},
			pushclass(){
				let allpageelement = document.getElementsByClassName('pagebtn2')
				let allpageelement2 = document.getElementsByClassName('pagebtn22')
				
				for(let i =0;i<allpageelement.length;i++){
					if(parseInt(allpageelement[i].innerHTML)===this.pageNum){
						allpageelement[i].className = 'pagebtn2 achievementpageselect'
						allpageelement2[i].className = 'pagebtn22 pageselect'
					}else{
						allpageelement[i].className = 'pagebtn2'
						allpageelement2[i].className = 'pagebtn22'
					}
				}
			},
			sy(){
				if(this.pageNum!=1){
					this.pageNum = 1
					this.getscoresList()
				}
			},
			syy(){
				if(this.pageNum>1){
					this.pageNum -= 1
					this.getscoresList()
				}
			},
			xyy(){
				if(this.pageNum < this.pages){
					this.pageNum += 1
					this.getscoresList()
				}
			},
			wy(){
				if(this.pageNum != this.pages){
					this.pageNum = this.pages
					this.getscoresList()
				}
			},
			setData(value){
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return  y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
			}
		}
	}
</script>

<style scoped>
	.achievement{
		background: #FFFFFF;
		border: 1px solid #a2693f;
	}
	.achievement .achievementpageselect{
		color: #FFFFFF !important;
	}
	.achievement .userborder{
		border: 1px solid #a2693f;
		margin: 1px;
	}
	.achievement .achievementitem{
		padding: 0.5rem;
		border-bottom: 1px dashed #dbb48a;
		display: flex;
	}
	.achievement .achievementitem:last-child{
		border: none;
	}
	.achievement .achievementitem:nth-child(even){
		background: #faf7f3;
	}
	.flex_1{
		width: 30%;
	}
	.flex_2{
		width: 25%;
	}
	.flex_3{
		width: 45%;
	}
	.achievement .flex1{
		height: 4rem;
	}
	.achievement .flex1 img{
		width: 1.3rem;
		height: 1.3rem;
		display: block;
		float: left;
		margin-top: 1.35rem;
		margin-right: 0.5rem;
	}
	.achievement .flex1 p{
		float: left;
		width: calc(100% - 2.5rem);
		height: 4rem;
		line-height: 4rem;
		color: #896247;
		font-size: 0.9rem;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		font-size: 1rem;
	}
	.achievement .flex1 span{
		color: #a73a29;
		font-weight: bold;
		font-size: 1.2rem;
	}
	.itemall {
		background: #f7e9d3;
		height: auto;
		position: relative;
		min-height: 8rem;
	}
	.ttttttt{
		line-height: 760px;
		text-align: center;
		width: 100%;
		color: #d49f79;
		font-size: 1.285714rem;
	}
</style>
